import defaultMarket from '@tns/lang/src/default-market.json';
import marketToLocale from '@tns/lang/src/market-to-locale.json';

import type { MarketType } from '../';

type MarketToLocal = { [key: string]: string };

function getLocaleSupportedForL10nOther(market: MarketType) {
  return (
    (marketToLocale as MarketToLocal)[market.marketCode] ||
    (marketToLocale as MarketToLocal)[defaultMarket]
  );
}

export default getLocaleSupportedForL10nOther;
